const results = [
  'более самостоятельные сотрудники — меньше обращаются к руководителю по каждому вопросу;',
  'понятные задачи — сотрудники точно знают, что и к какому сроку нужно сделать;',
  'меньше повторной работы — задачи выполняются правильно с первого раза;',
  'снижение микроменеджмента — руководитель перестаёт контролировать каждый шаг;',
  'высвобождение времени руководителей для стратегических задач;',
  'повышение ответственности сотрудников за результаты своей работы;',
  'более прозрачный контроль — сотрудники и руководители понимают, когда и как проверяется результат;',
  'развитие сотрудников через реальные рабочие задачи;',
  'более быстрая работа команды — меньше согласований и ожидания решений;',
  'повышение управленческой ёмкости руководителей — возможность управлять большим объёмом задач и более крупными командами.',
];

export default function CompanyResults() {
  return (
    <section id="results" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Возможные изменения при системном развитии навыков делегирования и постановки задач
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-3 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{r}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}